export const environment = {
  baseUrl: './',
  production: true,
  databaseUrl: 'http://localhost:5000', // TODO später auf richtige url umbiegen
  baseAdcmUrl: 'https://backend.adcm.airborne-division.de',
  wikiUrl: 'https://wiki.airborne-division.de',
};
